import {
  ignoreUserMutation,
  IgnoreUserMutationResponse,
  unignoreUserMutation,
  UnignoreUserMutationResponse,
} from "@framework/cyclone/graphql/mutation";
import { makeRequest } from "@framework/cyclone/request";

export const ignoreUser = async (
  userID: string,
  serverURL: string,
  communityID: string,
  token?: string | null,
) => {
  if (!token) {
    return;
  }

  const url = new URL("/api", serverURL);
  const response = await makeRequest<IgnoreUserMutationResponse>(
    url.toString(),
    ignoreUserMutation as string,
    { userID, communityID },
    token,
  );

  if (response.errors || !response.data) {
    return;
  }

  return response.data.ignoreUser;
};

export const unignoreUser = async (
  userID: string,
  serverURL: string,
  communityID: string,
  token?: string | null,
) => {
  if (!token) {
    return;
  }

  const url = new URL("/api", serverURL);
  const response = await makeRequest<UnignoreUserMutationResponse>(
    url.toString(),
    unignoreUserMutation as string,
    { userID, communityID },
    token,
  );

  if (response.errors || !response.data) {
    return;
  }

  return response.data.unignoreUser;
};
